const preloadedUrls = new Set<string>();

export const preloadImages = (imageUrls: string[]) => {
  imageUrls.forEach((url) => {
    if (preloadedUrls.has(url)) {
      return;
    }

    const img = new Image();
    img.src = url;
    img.onload = () => {
      preloadedUrls.add(url);
    };
    img.onerror = () => {
      console.warn(`Failed to prefetch: ${url}`);
    };
  });
};